export default "__VITE_ASSET__37199aa7__"